import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Link from 'next/link'
import type { NextPage } from 'next';
import styles from './index.module.scss';

import Wrapper from '@/components/wrapper';
import cName from 'classnames';
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation';
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useRouter } from 'next/router';
import classNames from 'classnames';
import { getServerSideProps as _getServerSideProps, getHead } from '@/utils/useHead';
import request from '@/utils/request';

interface IProps {

}

export async function getServerSideProps(context: any) {
  const res: any = await _getServerSideProps(context);
  const { data } = await request.get(`/api/product_category_list`)
  return {
    props: {
      ...res.props,
      data: data?.data || null
    }
  }
}

const Partner: NextPage<IProps> = ({ menuDetail, data }: any) => {
  const router = useRouter()

  const [active, setActive] = useState(0)

  useEffect(() => {
    const _index = data.findIndex((item: any) => item.id == router.query.cate)
    setActive(_index === -1 ? 0 : _index)
  }, [router])

  return (
    <div>
      <Wrapper>
        <div className={classNames(styles.container, 'm-1600')}>
          {getHead(menuDetail)}
          <Swiper
            className={styles.swiper}
            modules={[Navigation, Autoplay]}
            spaceBetween={30}
            // autoplay
            initialSlide={active}
            slidesPerView={'auto'}
            navigation
          >
            {
              data?.map((item: any, index: number) => (
                <SwiperSlide key={item.id}>
                  <Link href={`/about/range?cate=${item.id}`}>
                    <a className={cName([styles.cateList, {
                      [styles.active]: active === index
                    }])}>
                      <div className={styles.num}
                        style={{
                          opacity: active === index ? 1 : 0
                        }}>0{index + 1}</div>
                      <div>
                        <p>{item[`name_${router.locale}`]}</p>
                        {
                          router.locale === 'cn' && <span>{item.name_en}</span>
                        }
                      </div>
                      <img src={item.image_index} alt="" />
                    </a>
                  </Link>
                </SwiperSlide>
              ))
            }
          </Swiper>
          <div className={styles.imgList}>
            <h3>{data.length && data[active]?.[`name_${router.locale}`]}</h3>
            <p>{data.length && router.locale === 'cn' ? data[active]?.name_en : ''}</p>
            <ul
              className={classNames([{
                [styles.flex]: data.length
                  && data[active]?.childlist.length % 4 === 1,
                [styles.grid]: data.length
                  && data[active]?.childlist.length % 4 !== 1
              }])}
            >
              {
                data.length && data[active]?.childlist.map((item: any) => (
                  <li key={item.id} style={{
                    width: data.length
                      && data[active]?.childlist.length % 4 === 1
                      ? '32%' : '100%'
                  }}>
                    <Link href={item[`link_${router.locale}`] ? item[`link_${router.locale}`] : "javascript:;"}>
                      <a>
                        <div>
                          <img src={item.image} alt="" />
                        </div>
                        <p>{item[`name_${router.locale}`]}</p>
                      </a>
                    </Link>
                  </li>
                ))
              }
            </ul>
          </div>
          <style jsx global lang='scss'>
            {
              `
              .swiper-button-prev,
              .swiper-button-next{
                width:40px;
                height:40px;
                border-radius:50%;
                background-color:#fcb814;
              }
              .swiper-button-prev::after,
              .swiper-button-next::after{
                color:#231f20;
                transform: scale(0.3);
                font-weight: 900;
              }

              .swiper-slide{
                width:auto;
              }
              .swiper{
                overflow: visible;
              }
              @media screen and (max-width: 800px) {

              }
            `
            }
          </style>
        </div>
      </Wrapper >
    </div >
  );
};

export default Partner;
